import React from "react";
import { Box } from "@mui/material";
import DOMPurify from "dompurify";

interface Props {
  content: string;
}

const RichTextDisplay: React.FC<Props> = ({ content }: { content: string }) => {
  const sanitizedContent = DOMPurify.sanitize(content);

  return (
    <Box
      className="ql-editor" // Aplica os estilos do Quill
      dangerouslySetInnerHTML={{ __html: sanitizedContent }}
      sx={{
        padding: "0 !important",
      }}
    />
  );
};

export default RichTextDisplay;
